import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrush: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrush"><Path d="M13.4998 18.5001L13.1223 18.1222C11.9509 16.9497 10.0505 16.9492 8.87858 18.1213L5.50055 21.4995L2.5 18.5001L5.87865 15.1212C7.05058 13.9492 7.05006 12.0489 5.87749 10.8776L5.49982 10.5003L13.4997 2.5L17.4997 6.5L17.4997 8.5H19.4997L21.4997 10.5L13.4998 18.5001Z" stroke="currentColor"/><Path d="M16.5 15.5L8.5 7.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBrush;
